var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { QUERY_KEYS } from '@libs/@core/constants/key';
import { useSnackbarContext } from '@libs/@core/contexts/snackbarContext';
import axiosServices from '@libs/@core/axios';
import API_URL from '@libs/@core/constants/endpointApi';
import { CF_TEMPLATE_URL } from '@src/routes/url';
var editCfTemplateMutation = function (id, data) { return __awaiter(void 0, void 0, void 0, function () {
    var set, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                set = new Set(data.requireColumns);
                if (!set.has(data.amountIndex)) {
                    set.add(data.amountIndex);
                }
                return [4 /*yield*/, axiosServices.put("".concat(API_URL.CASHFLOW_TEMPLATE.POST, "/").concat(id), __assign(__assign({}, data), { requireColumns: Array.from(set) }))];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); };
var useEditCFTemplateMutation = function () {
    var navigate = useNavigate();
    var queryClient = useQueryClient();
    var snackbar = useSnackbarContext();
    var editCfTemplate = useMutation({
        mutationFn: function (_a) {
            var id = _a.id, data = _a.data;
            return editCfTemplateMutation(id, data);
        },
        onSuccess: function () {
            queryClient.invalidateQueries({
                queryKey: [QUERY_KEYS.CASHFLOW_TEAMPLATE_LIST]
            });
            snackbar.success('Edit cashflow template successfully');
            navigate(CF_TEMPLATE_URL);
        },
        onError: function () {
            snackbar.error('Edit cashflow template failed');
        }
    });
    return __assign({}, editCfTemplate);
};
export default useEditCFTemplateMutation;
